import { useEffect, useState } from 'react';

const N = (x: any) => (Number(x) || 0).toLocaleString();
function Card({ title, children }: { title: string; children: any }) {
  return <div className="card p-3"><div className="text-sm font-semibold mb-2">{title}</div>{children}</div>;
}

export default function CdrInsights() {
  const [lb, setLb] = useState<any>(null);
  const [trunks, setTrunks] = useState<any>(null);
  const [health, setHealth] = useState<any>(null);
  const [err, setErr] = useState<string | null>(null);
  const [month, setMonth] = useState(new Date().toISOString().slice(0, 7));

  async function load() {
    setErr(null);
    try {
      const l = await (await fetch('/cdr/api/leaderboards', { credentials: 'include' })).json();
      if (l.error) { setErr(l.error); return; }
      setLb(l);
      setTrunks(await (await fetch('/cdr/api/trunks?days=3', { credentials: 'include' })).json());
      setHealth(await (await fetch('/cdr/api/ingesthealth', { credentials: 'include' })).json());
    } catch (e: any) { setErr(String(e)); }
  }
  useEffect(() => { load(); /* eslint-disable-next-line */ }, []);

  return (
    <div className="space-y-4">
      {err && <div className="text-xs text-red-500">Sign in to the CDR portal to view ({err}).</div>}

      <div className="card p-3 flex gap-2 items-center flex-wrap text-xs">
        <span className="font-semibold">Monthly report</span>
        <input type="month" value={month} onChange={e => setMonth(e.target.value)} className="border rounded px-2 py-1 bg-transparent" />
        <button onClick={() => window.open('/cdr/report/monthly?month=' + month, '_blank')} className="px-3 py-1 rounded bg-tnh-accent text-white">Open / Print PDF</button>
        <span className="text-gray-500">Opens a print-ready report — use your browser's Print to save as PDF.</span>
      </div>

      {health && (
        <Card title="Ingest health">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-2 text-xs">
            <div className="tile card p-2"><div className="font-semibold">{health.last_cdr || '—'}</div><div className="text-gray-500">last call</div></div>
            <div className="tile card p-2"><div className="font-semibold">{health.minutes_since_last_call != null ? health.minutes_since_last_call + ' min' : '—'}</div><div className="text-gray-500">since last call</div></div>
            <div className="tile card p-2"><div className="font-semibold">{health.hours_covered_3d}/{health.hours_expected_3d}</div><div className="text-gray-500">hours covered (3d)</div></div>
            <div className={'tile card p-2 ' + ((health.missing_days || []).length ? 'text-red-500' : '')}><div className="font-semibold">{(health.missing_days || []).length}</div><div className="text-gray-500">missing days</div></div>
          </div>
          {(health.missing_days || []).length > 0 && <div className="text-[11px] text-red-500 mt-2">Gaps: {health.missing_days.join(', ')}</div>}
        </Card>
      )}

      <div className="grid md:grid-cols-2 gap-4">
        <Card title="Top users (outbound, 30d)">
          <table className="w-full text-xs"><thead className="text-gray-500"><tr><th className="text-left px-2 py-1">User</th><th className="text-right px-2 py-1">Calls</th><th className="text-right px-2 py-1">Min</th></tr></thead>
            <tbody>{(lb?.top_users || []).map((u: any, i: number) => <tr key={i} className="border-t border-gray-100 dark:border-gray-800"><td className="px-2 py-1">{u.u}</td><td className="px-2 py-1 text-right">{N(u.calls)}</td><td className="px-2 py-1 text-right">{N(u.minutes)}</td></tr>)}</tbody></table>
        </Card>
        <Card title="Top called numbers (external, 30d)">
          <table className="w-full text-xs"><thead className="text-gray-500"><tr><th className="text-left px-2 py-1">Number</th><th className="text-right px-2 py-1">Calls</th><th className="text-right px-2 py-1">Min</th></tr></thead>
            <tbody>{(lb?.top_called || []).map((u: any, i: number) => <tr key={i} className="border-t border-gray-100 dark:border-gray-800"><td className="px-2 py-1 font-mono">{u.n}</td><td className="px-2 py-1 text-right">{N(u.calls)}</td><td className="px-2 py-1 text-right">{N(u.minutes)}</td></tr>)}</tbody></table>
        </Card>
        <Card title="Most-expensive departments (this month)">
          <table className="w-full text-xs"><thead className="text-gray-500"><tr><th className="text-left px-2 py-1">Department</th><th className="text-right px-2 py-1">Calls</th><th className="text-right px-2 py-1">Cost</th></tr></thead>
            <tbody>{(lb?.top_departments || []).map((d: any, i: number) => <tr key={i} className="border-t border-gray-100 dark:border-gray-800"><td className="px-2 py-1">{d.department}</td><td className="px-2 py-1 text-right">{N(d.calls)}</td><td className="px-2 py-1 text-right">${(d.cost || 0).toFixed(2)}</td></tr>)}</tbody></table>
        </Card>
        <Card title="Trunk / location concurrency (3d)">
          <table className="w-full text-xs"><thead className="text-gray-500"><tr><th className="text-left px-2 py-1">Location</th><th className="text-right px-2 py-1">Calls</th><th className="text-right px-2 py-1">Peak concurrent</th></tr></thead>
            <tbody>{(trunks?.locations || []).map((t: any, i: number) => <tr key={i} className="border-t border-gray-100 dark:border-gray-800"><td className="px-2 py-1">{t.location}</td><td className="px-2 py-1 text-right">{N(t.calls)}</td><td className="px-2 py-1 text-right font-semibold">{N(t.peak_concurrent)}</td></tr>)}</tbody></table>
        </Card>
      </div>
    </div>
  );
}
